module.exports = __webpack_public_path__ + "img/electrovalence-gu@2x.529d3e6a.png";